import { lazy } from 'react';

export const ChangeWizard = lazy(
  () => import('@/capabilities/customer-lifecycle/pages/ChangeWizard')
);

export {
  AssessorRules,
  BenchmarkCatalogue,
  ContactDetail,
  ContactList,
  ContentBlockLibrary,
  ContractList,
  Day1PlanPage,
  EngagementDashboard,
  EstimateList,
  MSABuilder,
  MSAComparator,
  NewClientOnboardingPage,
  PendingChangesPage,
  PresentationMaker,
  PriceComparison,
  PricingCalculator,
  ProductGapAnalysis,
  ProfitabilityDashboard,
  ProposalComposer,
  ProposalList,
  ProposalPipeline,
  ProposalView,
  ProposalWizardPage,
  QBRBuilderPage,
  QBRPage,
  RenewalCalendarPage,
  RiskRegister,
  RoadmapBuilderPage,
  SatisfactionDashboard,
  ServiceCatalog,
  ServiceTerms,
  TechRoadmapEditor,
  TechRoadmapList,
  TechRoadmapTemplates,
} from '@/capabilities/customer-lifecycle/routes';

// Service Operations Suite (PSA)
// Block F.3.b — service-operations/Dashboard.tsx deleted. /dashboard now redirects to
// /workbench via <Navigate> in App.tsx per route-disposition.ts.
// V3 detail surface — full cockpit drill-in (replaces V2 split-pane detail
// panel). List view stays on TicketsV2 since the sandbox didn't ship a list
// V3 (and the V2 list works). The route /tickets/:id mounts TicketDetail.
// TicketKanban kanban view consolidated into TicketsV2 (the single combined
// list+detail surface). The kanban shape never shipped a V2 — for now it
// reuses the V2 list. Future: add a kanban-mode tab inside TicketsV2.
export const BillingDashboard = lazy(
  () => import('@/capabilities/customer-lifecycle/pages/customer-lifecycle/ContractsBillingV2')
);

// Roadmap (IT Client Roadmap Builder)
export { RoadmapEditor, RoadmapList } from '@/capabilities/customer-lifecycle/routes';

export { OrgChart } from '@/capabilities/customer-lifecycle/routes';

// Block D — Portfolio destination pages
export {
  PortfolioAnalyticsPage,
  PortfolioClientDetailPage,
  PortfolioClientsPage,
  PortfolioHealthPage,
  PortfolioReportsPage,
  PortfolioWorkplaceIntelligencePage,
} from '@/capabilities/customer-lifecycle/routes';
